/**
 * Javascript specific to the Content Drawer Slider
 * Hide/Show Drawer on page
 */

(function (window, document, $) {
	"use strict";

	// "Open" Drawer when link or Tab is clicked
	$(".drawer-trigger a").click(function (e) {
		e.preventDefault();
		$(".content-drawer").addClass("drawer_open");
		$(".drawer-modal").removeClass("modal_hide");
		// We need to hide the preferences section, find the 'Timely & Topical' checkbox, and check it only in the CTA subscription form.
		$(".content-drawer .user-preferences-section-cta").hide();
		$(
			".content-drawer .user-preferences-section-cta .subscription-checklist__checkbox-wrap"
		)
			.filter(function () {
				return (
					$(this).find(".blog-updates__label").text() ===
					"Timely & Topical"
				);
			})
			.find('input[type="checkbox"]')
			.click();
	});

	// "Close" Drawer when Close btn is clicked
	$(".content-drawer .close-btn").click(function () {
		$(".content-drawer").removeClass("drawer_open");
		$(".drawer-modal").addClass("modal_hide");
	});

	// "Close" drawer when Modal bkg is clicked
	$(".drawer-modal").click(function () {
		$(".content-drawer").removeClass("drawer_open");
		$(".drawer-modal").addClass("modal_hide");
	});

	/*
	 * Open the subscription drawer after scrolling
	 */

	// Function to set a cookie
	function setCookie(name, value, days) {
		let expires = "";
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}

	// Function to get a cookie
	function getCookie(name) {
		const nameEQ = name + "=";
		const ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0)
				return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	// Event listener for scroll - Currently limited to article pages, so we don't monitor scroll on all pages.
	if (document.body.classList.contains("single-jh_article")) {
		// Check if the cookie exists - if it does, don't set up scroll listener
		if (getCookie("drawerClickTriggered")) {
			return;
		}

		window.addEventListener("scroll", function () {
			// Check if the cookie exists
			if (getCookie("drawerClickTriggered")) {
				return;
			}

			// Calculate scroll percentage
			const scrollHeight =
				document.documentElement.scrollHeight - window.innerHeight;
			const scrollPosition = window.scrollY;
			const scrollPercentage = (scrollPosition / scrollHeight) * 100;

			// Check if scrolled more than 50%
			if (scrollPercentage >= 50) {
				// Try to find the drawer trigger element
				const drawerTrigger = document.querySelector("#drawer-trigger-cta a") || 
									document.querySelector(".drawer-trigger a") ||
									document.querySelector("#drawer-trigger-cta");

				if (drawerTrigger) {
					// Trigger the click to open the drawer
					drawerTrigger.click();
					
					// Set the cookie after the drawer is triggered
					setCookie("drawerClickTriggered", "true", 1); // The cookie expires in 1 day
				} else {
					console.warn("Drawer trigger element not found");
				}
			}
		});
	}
})(window, document, jQuery);
